module.exports = __webpack_public_path__ + "img/ko_kr.b28e1463.png";